import React from "react";
import {
  DataCard,
  DataCardMultilineItem,
  DataCardListItem,
} from "@ofqual/portal-components/components/DataCard/DataCard";
import { AssessmentExpertiseModel } from "../../domain/AssessmentExpertiseModel";
import { ExpertiseType, SubjectModel } from "../../domain/SubjectModel";
import { useDisplaySubjects } from "../../hooks/useRefSubjects";
import { RefSubjectModel } from "../../domain/RefSubjectModel";
import { Grid } from "@material-ui/core";

export const AssessmentExpertise: React.FC<{
  assessmentExpertise: AssessmentExpertiseModel;
  subjects: SubjectModel[];
  refSubjects: RefSubjectModel[];
  dialogTitle: string;
}> = ({ assessmentExpertise, subjects, refSubjects }) => {
  const {
    displaySubjects,
  } = useDisplaySubjects(subjects, refSubjects, ExpertiseType.Assessment);

  const displayAssessmentExpertise = (
    assessmentExpertise: AssessmentExpertiseModel
  ) => {
    let items: (DataCardMultilineItem | DataCardListItem)[] = [];

    if (subjects.some((s) => s.expertiseType & ExpertiseType.Assessment)) {
      items.push({
        itemType: "LIST",
        key: "Subjects",
        value: displaySubjects.filter((s) => s !== ""),
      });
    }

    if (assessmentExpertise?.designAndDevelopmentAssessmentDetails) {
      items.push({
        itemType: "MULTILINE",
        key: "Provide details of your experience in designing and developing assessments",
        value: assessmentExpertise.designAndDevelopmentAssessmentDetails,
      });
    }

    if (assessmentExpertise?.makingAssessmentJudgement) {
      items.push({
        itemType: "MULTILINE",
        key: "Provide details of your experience in making assessment judgements",
        value: assessmentExpertise.makingAssessmentJudgement,
      });
    }

    if (assessmentExpertise?.standardAwardingQualifications) {
      items.push({
        itemType: "MULTILINE",
        key: "Provide details of your experience in standard setting and awarding qualifications",
        value: assessmentExpertise.standardAwardingQualifications,
      });
    }

    if (assessmentExpertise?.assessmentEvaluationDetails) {
      items.push({
        itemType: "MULTILINE",
        key: "Provide details of your experience in evaluating assessments or assessment approaches",
        value: assessmentExpertise.assessmentEvaluationDetails,
      });
    }

    if (assessmentExpertise?.designAndDevelopmentAssessmentFurtherEvidence) {
      items.push({
        itemType: "MULTILINE",
        key: "Further evidence in your experience in designing and developing assessments",
        value: assessmentExpertise?.designAndDevelopmentAssessmentFurtherEvidence,
      });
    }

    if (assessmentExpertise?.makingAssessmentJudgementFurtherEvidence) {
      items.push({
        itemType: "MULTILINE",
        key: "Further evidence in your experience in making assessment judgements",
        value: assessmentExpertise.makingAssessmentJudgementFurtherEvidence,
      });
    }

    if (assessmentExpertise?.standardAwardingQualificationsFurtherEvidence) {
      items.push({
        itemType: "MULTILINE",
        key: "Further evidence in your experience in standard setting and awarding qualifications",
        value: assessmentExpertise.standardAwardingQualificationsFurtherEvidence,
      });
    }

    if (assessmentExpertise?.assessmentEvaluationFurtherEvidence) {
      items.push({
        itemType: "MULTILINE",
        key: "Further evidence in your experience in assessment evaluation",
        value: assessmentExpertise.assessmentEvaluationFurtherEvidence,
      });
    }

    return items;
  };

  return (
    <>
      <div style={{ overflowWrap: 'break-word' }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <DataCard
              showHeading={false}
              heading={null}
              items={displayAssessmentExpertise(assessmentExpertise)}
              hasAction={false}
              actionDescription={null}
              actionButtonText={null}
              actionFunction={null}
              headingComponent={"h1"}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
};
